import React from 'react';
//import {loadTimelineData} from 'anima-timeline';
import "./InsightDetailPage.css";
import NavBar from "../NavBar";
import Footer from "../Footer";
//import {InSights_Detail} from "../../data";
import InsightsDetails from "../../Common/InsightsDetails";

//import {Link} from "react-router-dom";

// function App() {
//   return <X07InsightsPageDETAILSDesktop {...props} />;
// }

// export default App;

export default function X07InsightsPageDETAILSDesktop(props) {
  // const {
  //   bbmp,
  //   rectangle85,
  //   spanText,
  //   spanText2,
  //   spanText3,
  //   spanText4,
  //   spanText5,
  //   text77,
  //   image9,
  //   spanText6,
  //   spanText7,
  //   spanText8,
  //   spanText9,
  //   spanText10,
  //   spanText11,
  //   spanText12,
  //   spanText13,
  //   spanText14,
  //   spanText15,
  //   //headerWithBackground11Props,
  //   //footer32Props,
  // } = props;

  return (
    <div className="idpd-container-center-horizontal">    
      <div className="idpd-x07-insights-page-details-desktop">
        {/* <HeaderWithBackground11 {...headerWithBackground11Props} /> */}
        <NavBar />
        <InsightsDetails {...props}/>
        <Footer />
      </div>
      
    </div>
  );
}


// function HeaderWithBackground11(props) {
//   const {
//     unselectedI2601268,
//     unselectedI26012682,
//     unselectedI26012683,
//     unselectedI26012684,
//     text38,
//     unselectedI26012685,
//     unselectedI26012686,
//     unselectedI26012687,
//     group86Props,
//     getAQuoteButton22Props,
//   } = props;

//   return (
//     <div className="idpd-header-with-background">
//       <Group86 group85={group86Props.group85} whiteProps={group86Props.whiteProps} />
//       <div className="idpd-frame-34">
//         <div className="idpd-frame-27">
//           <Link to="/">
//           <div className="idpd-unselected-i2601269 idpd-valign-text-middle idpd-typography-body-smalltext-14-regular">
//             {unselectedI2601268}
//           </div>
//           </Link>
//           <Link to="/about">
//           <div className="idpd-unselected-i2601269-1 idpd-valign-text-middle idpd-typography-body-smalltext-14-regular">
//             {unselectedI26012682}
//           </div>
//           </Link>
//           <Link to="/project">
//           <div className="idpd-unselected-i2601269-2 idpd-valign-text-middle idpd-typography-body-smalltext-14-regular">
//             {unselectedI26012683}
//           </div>
//           </Link>
//           <Link to="/video">
//           <div className="idpd-unselected-i2601269-3 idpd-valign-text-middle idpd-typography-body-smalltext-14-regular">
//             {unselectedI26012684}
//           </div>
//           </Link>
//           <div className="idpd-selected">
//             <div className="idpd-overlap-group">
//               <div className="idpd-rectangle-61"></div>
//               <Link to="/insight">
//               <div className="idpd-text-31 idpd-valign-text-middle">{text38}</div>
//               </Link>
//             </div>
//           </div>
//           <Link to="/blog">
//           <div className="idpd-unselected-i2601269-4 idpd-valign-text-middle idpd-typography-body-smalltext-14-regular">
//             {unselectedI26012685}
//           </div>
//           </Link>
//           <Link to="/faq">
//           <div className="idpd-unselected-i2601269-5 idpd-valign-text-middle idpd-typography-body-smalltext-14-regular">
//             {unselectedI26012686}
//           </div>
//           </Link>
//           <Link to="/contactus">
//           <div className="idpd-unselected-i2601269-6 idpd-valign-text-middle idpd-typography-body-smalltext-14-regular">
//             {unselectedI26012687}
//           </div>
//           </Link>
//         </div>
//         <GetAQuoteButton222>{getAQuoteButton22Props.children}</GetAQuoteButton222>
//       </div>
//     </div>
//   );
// }


// function Group86(props) {
//   const { group85, whiteProps } = props;

//   return (
//     <div className="idpd-group-86">
//       <White src={whiteProps.src} />
//       <img className="idpd-group-85" src={group85} />
//     </div>
//   );
// }


// function White(props) {
//   const { src } = props;

//   return (
//     <div className="idpd-white">
//       <img className="idpd-vector" src={src} />
//     </div>
//   );
// }


// function GetAQuoteButton222(props) {
//   const { children } = props;

//   useEffect(() => {
//     loadTimelineData(i2601269764120TimelineData);
//   }, []);

//   return (
//     <div className="idpd-i26012697-64120 component component-wrapper not-ready">
//       <div className="idpd-master-button-7oiNQN">
//         <div className="idpd-button-i2601269764-VjD0Fx idpd-valign-text-middle">{children}</div>
//       </div>
//     </div>
//   );
// }

// const i2601269764120TimelineData = [
//   {
//     initial_state_name: "Property-1=Primary",
//     root_element: ".i26012697-64120",
//     states_flow: {
//       "Property-1=Primary": {
//         listeners: [],
//         overrides: {},
//       },
//       "Property-1=Secondary": {
//         listeners: [],
//         overrides: {},
//       },
//       "Property-1=Tertiary": {
//         listeners: [],
//         overrides: {},
//       },
//     },
//   },
// ];


// function Footer32(props) {
//   const { group32Props, frame5Props, frame6Props, frame7Props } = props;

//   return (
//     <div className="idpd-footer">
//       <div className="idpd-frame-1585">
//         <Frame1578
//           overlapGroup1={group32Props.overlapGroup1}
//           vector2={group32Props.vector2}
//           group86222Props={group32Props.group86222Props}
//           facebookAppSymbol3Props={group32Props.facebookAppSymbol3Props}
//           twitter3Props={group32Props.twitter3Props}
//         />
//         <Frame53 text40={frame5Props.text40} frame4Props={frame5Props.frame4Props} />
//         <Frame6
//           text48={frame6Props.text48}
//           frame42Props={frame6Props.frame42Props}
//           frame422Props={frame6Props.frame422Props}
//         />
//       </div>
//       <Frame7 text56={frame7Props.text56} frame4Props={frame7Props.frame4Props} />
//     </div>
//   );
// }


// function Frame1578(props) {
//   const { overlapGroup1, vector2, group86222Props, facebookAppSymbol3Props, twitter3Props } = props;

//   return (
//     <div className="idpd-frame-1578">
//       <Group86222 group85={group86222Props.group85} whiteProps={group86222Props.whiteProps} />
//       <div className="idpd-frame-1584">
//         <Group324 />
//         <div className="idpd-frame-1583">
//           <FacebookAppSymbol3 src={facebookAppSymbol3Props.src} />
//           <div className="idpd-instagram">
//             <div className="idpd-overlap-group-1" style={{ backgroundImage: `url(${overlapGroup1})` }}>
//               <img
//                 className="idpd-vector-1"
//                 src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-95@2x.svg"
//               />
//               <img className="idpd-vector-2" src={vector2} />
//             </div>
//           </div>
//           <Twitter3 src={twitter3Props.src} />
//         </div>
//       </div>
//     </div>
//   );
// }


// function Group86222(props) {
//   const { group85, whiteProps } = props;

//   return (
//     <div className="idpd-group-86-1">
//       <White src={whiteProps.src} />
//       <img className="idpd-group-85-1" src={group85} />
//     </div>
//   );
// }


// function Group324() {
//   return (
//     <div className="idpd-group-32">
//       <div className="idpd-group-189">
//         <div className="idpd-map-pin-1">
//           <div className="idpd-overlap-group-2">
//             <img
//               className="idpd-vector-3"
//               src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-90@2x.svg"
//             />
//           </div>
//         </div>
//         <p className="idpd-text-1 idpd-typographybody16-regular">
//           #8, 105, Vishal Park Word, 3rd Cross, Cambridge Road Ulsoor, Bangalore, Bengaluru, Karnataka 560008
//         </p>
//       </div>
//       <div className="idpd-group-18">
//         <div className="idpd-phone">
//           <img
//             className="idpd-vector-4"
//             src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-111@2x.svg"
//           />
//         </div>
//         <div className="idpd-text idpd-valign-text-middle idpd-typographybody16-regular">+91 8976535221, +91 8755645342</div>
//       </div>
//       <div className="idpd-group-18">
//         <div className="idpd-mail">
//           <div className="idpd-overlap-group-3">
//             <img
//               className="idpd-vector-5"
//               src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-93@2x.svg"
//             />
//           </div>
//         </div>
//         <div className="idpd-text idpd-valign-text-middle idpd-typographybody16-regular">contact@webuild.com</div>
//       </div>
//     </div>
//   );
// }


// function FacebookAppSymbol3(props) {
//   const { src } = props;

//   return (
//     <div className="idpd-facebook-app-symbol">
//       <img className="idpd-f-1" src={src} />
//     </div>
//   );
// }


// function Twitter3(props) {
//   const { src } = props;

//   return (
//     <div className="idpd-twitter">
//       <img className="idpd-vector-6" src={src} />
//     </div>
//   );
// }


// function Frame53(props) {
//   const { text40, frame4Props } = props;

//   return (
//     <div className="idpd-frame-5">
//       <div className="idpd-text-4 idpd-valign-text-middle idpd-typographyheadlineh5-extrabold-20">{text40}</div>
//       <Frame4
//         text41={frame4Props.text41}
//         text42={frame4Props.text42}
//         text43={frame4Props.text43}
//         text44={frame4Props.text44}
//         text45={frame4Props.text45}
//         text46={frame4Props.text46}
//         text47={frame4Props.text47}
//       />
//     </div>
//   );
// }


// function Frame4(props) {
//   const { text41, text42, text43, text44, text45, text46, text47 } = props;

//   return (
//     <div className="idpd-frame-4">
//       <div className="idpd-text-2 idpd-valign-text-middle idpd-typographybody16-regular">{text41}</div>
//       <div className="idpd-text-3 idpd-valign-text-middle idpd-typographybody16-regular">{text42}</div>
//       <div className="idpd-text-3 idpd-valign-text-middle idpd-typographybody16-regular">{text43}</div>
//       <div className="idpd-text-3 idpd-valign-text-middle idpd-typographybody16-regular">{text44}</div>
//       <div className="idpd-text-3 idpd-valign-text-middle idpd-typographybody16-regular">{text45}</div>
//       <div className="idpd-text-3 idpd-valign-text-middle idpd-typographybody16-regular">{text46}</div>
//       <div className="idpd-text-3 idpd-valign-text-middle idpd-typographybody16-regular">{text47}</div>
//     </div>
//   );
// }


// function Frame6(props) {
//   const { text48, frame42Props, frame422Props } = props;

//   return (
//     <div className="idpd-frame-6">
//       <div className="idpd-text-12 idpd-valign-text-middle idpd-typographyheadlineh5-extrabold-20">{text48}</div>
//       <div className="idpd-frame-1577">
//         <Frame42
//           text49={frame42Props.text49}
//           text50={frame42Props.text50}
//           place={frame42Props.place}
//           text51={frame42Props.text51}
//           text52={frame42Props.text52}
//         />
//         <Frame42
//           text49={frame422Props.text49}
//           text50={frame422Props.text50}
//           place={frame422Props.place}
//           text51={frame422Props.text51}
//           text52={frame422Props.text52}
//           className={frame422Props.className}
//         />
//       </div>
//     </div>
//   );
// }


// function Frame42(props) {
//   const { text49, text50, place, text51, text52, className } = props;

//   return (
//     <div className={`idpd-frame-4-1 ${className || ""}`}>
//       <div className="idpd-text-13 idpd-valign-text-middle idpd-overpass-extra-bold-white-16px">{text49}</div>
//       <div className="idpd-frame-1580">
//         <div className="idpd-text-1-1 idpd-valign-text-middle idpd-typographybody16-regular">{text50}</div>
//         <div className="idpd-place idpd-valign-text-middle idpd-typographybody16-regular">{place}</div>
//         <div className="idpd-text-15 idpd-valign-text-middle idpd-typographybody16-regular">{text51}</div>
//         <div className="idpd-text-16 idpd-valign-text-middle idpd-typographybody16-regular">{text52}</div>
//       </div>
//     </div>
//   );
// }


// function Frame7(props) {
//   const { text56, frame4Props } = props;

//   return (
//     <div className="idpd-frame-7">
//       <div className="idpd-text-20 idpd-valign-text-middle idpd-typographyheadlineh5-extrabold-20">{text56}</div>
//       <Frame4
//         text41={frame4Props.text41}
//         text42={frame4Props.text42}
//         text43={frame4Props.text43}
//         text44={frame4Props.text44}
//         text45={frame4Props.text45}
//         text46={frame4Props.text46}
//         text47={frame4Props.text47}
//       />
//     </div>
//   );
// }

// const whiteData = {
//     src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-98@2x.svg",
// };

// const group86Data = {
//     group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/WebuilddLogo.svg",
//     whiteProps: whiteData,
// };

// const getAQuoteButton222Data = {
//     children: "GET A QUOTE",
// };

// const headerWithBackground11Data = {
//     unselectedI2601268: "HOME",
//     unselectedI26012682: "ABOUT US",
//     unselectedI26012683: "PROJECTS",
//     unselectedI26012684: "VIDEOS",
//     text38: "INSIGHTS",
//     unselectedI26012685: "BLOGS",
//     unselectedI26012686: "FAQ’S",
//     unselectedI26012687: "CONTACT US",
//     group86Props: group86Data,
//     getAQuoteButton22Props: getAQuoteButton222Data,
// };

// const white2Data = {
//     src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-88@2x.svg",
// };

// const group86222Data = {
//     group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/Webuildd-Logo-White.svg",
//     whiteProps: white2Data,
// };

// const facebookAppSymbol3Data = {
//     src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1@2x.svg",
// };

// const twitter3Data = {
//     src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-97@2x.svg",
// };

// const frame1578Data = {
//     overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-94@2x.svg",
//     vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-96@2x.svg",
//     group86222Props: group86222Data,
//     facebookAppSymbol3Props: facebookAppSymbol3Data,
//     twitter3Props: twitter3Data,
// };

// const frame4Data = {
//     text41: "About Us",
//     text42: "Projects",
//     text43: "Videos",
//     text44: "Packages",
//     text45: "Insights",
//     text46: "Blogs",
//     text47: "FAQ’s",
// };

// const frame53Data = {
//     text40: "Quick Links",
//     frame4Props: frame4Data,
// };

// const frame42Data = {
//     text49: "Construction",
//     text50: "Basic",
//     place: "Standard",
//     text51: "Premium",
//     text52: "Luxury",
// };

// const frame422Data = {
//     text49: "Interior",
//     text50: "Basic",
//     place: "Standard",
//     text51: "Premium",
//     text52: "Luxury",
//     className: "idpd-frame-5-1",
// };

// const frame6Data = {
//     text48: "Packages",
//     frame42Props: frame42Data,
//     frame422Props: frame422Data,
// };

// const frame43Data = {
//     text41: "BBEMP",
//     text42: "BWSSB",
//     text43: "BESCOM",
//     text44: "Procedure",
//     text45: "Vaastu",
//     text46: "Bye Laws",
//     text47: "Tips & Ideas",
// };

// const frame7Data = {
//     text56: "Insights",
//     frame4Props: frame43Data,
// };

// const footer32Data = {
//     group32Props: frame1578Data,
//     frame5Props: frame53Data,
//     frame6Props: frame6Data,
//     frame7Props: frame7Data,
// };

// const x07InsightsPageDETAILSDesktopData = {
//     bbmp: "BBMP",
//     rectangle85: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60d5732641e2212c658d387b/img/rectangle-85-2@2x.jpg",
//     spanText: "The ",
//     spanText2: "Bruhat Bengaluru Mahanagara Palike",
//     spanText3: " or the ",
//     spanText4: "BBMP",
//     spanText5: <> is the authority managing the innumerable infrastructure and civic amenities in Greater Bengaluru. Therefore, getting clearance and approval from the BBMP before implementing the building construction is a crucial step. The BBMP authorities have the power to demolish the building already constructed or levy a huge price as a penalty for illegal construction under its jurisdiction. <br /><br />However, you can be guaranteed that by following the right procedure with the submission of appropriate documents and paying the prescribed fee, the verification will be done by the concerned BBMP authorities and you will have all your documents approved and clearance within a span of 30 days.</>,
//     text77: "How to submit building plan approval application?",
//     image9: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60d5732641e2212c658d387b/img/image-9@2x.jpg",
//     spanText6: <ul><li>The application forms for approval can be downloaded from the official website: ___ and submitted online or offline.<br /></li><li>The choice of forms and the authorized officer to sanction the application is dependent on the size of the building plan. The different forms are attached for your perusal to give you better clarity on the terms and details asked in the set documents.<br /></li><li>By duly filling in the suitable application form according to your building size and submitting the following original documents along will enable a hassle-free process –<br /></li></ul>,
//     spanText7: "      Latest BBMP Khata Certificate",
//     spanText8: "   ",
//     spanText9: " |",
//     spanText10: "    ",
//     spanText11: "Latest Khata Extract ",
//     spanText12: "   ",
//     spanText13: "|",
//     spanText14: "   ",
//     spanText15: " Latest Tax Paid Receipt",
//     //headerWithBackground11Props: headerWithBackground11Data,
//     //footer32Props: footer32Data,
// };
